module.exports = __webpack_public_path__ + "static/media/Sign up.ad16dec9.jpg";